import { TenantDto } from '@careapp-group/ng-sdk';
import { caCreateEntitySelectors } from '../entity-state/entity-selectors';
import { CaEntityState } from '../entity-state/entity-state';

export const TenantSelectors = caCreateEntitySelectors<TenantDto, CaEntityState<TenantDto>>(
  'tenants',
);
